import {BaseCachedService} from './Core/BaseCachedService';

class SpeciesRequestSourceService extends BaseCachedService {
    get Url() { return super.Url + "/speciesRequestSource"; }
    get ModelName() { return "Species Request Source"; }
    get PrimaryKeyProperty() { return "speciesRequestSourceId"; }
    get TitleProperty() { return "name"; }
}

export const service = new SpeciesRequestSourceService();

